import { cleanupBootstrapModalBody } from '../shared/bootstrap-modal-cleanup.js';
import { showAlertMsg } from './member-show-alert-msg.js';
import { openIndexPage } from './member-open-index-page.js';

export function initMemberPledgeAddModal(config, hooks) {
    hooks = hooks || {};
    const routes = config.routes || {};
    const csrfToken = config.csrfToken || '';
    const modalSelector = '#addPledgeModal';
    const formSelector = '#validPledge';
    const amountChoiceSelector = '#amt_choice_option';
    const matanahSwitchSelector = '#matanah_switch';
    const amountRowSelector = '#pledge_amount_row';
    const amountSelector = '#amount';
    const pledgeDateSelector = '#pledge_date';
    const datepickerSelector = '#pledge_datepicker';
    const amountErrorSelector = '#enter_amt_err';
    const bindNamespace = '.memberPledgeAddModal';

    if (!routes.memberPledgeSave) {
        throw new Error('member pledge add modal requires routes.memberPledgeSave');
    }

    const $modal = $(modalSelector);
    if (!$modal.length) {
        throw new Error('initMemberPledgeAddModal: ' + modalSelector + ' is required');
    }
    const $form = $modal.find(formSelector);

    function todayDisplayDate() {
        const today = new Date();
        return (today.getMonth() + 1).toString().padStart(2, '0') + '/'
            + today.getDate().toString().padStart(2, '0') + '/'
            + today.getFullYear();
    }

    function setAmountInputMode() {
        $modal.find(amountSelector).prop({ type: config.useVirtualKeyboard ? 'text' : 'number' });
    }

    function resetDate() {
        const formattedDate = todayDisplayDate();
        $modal.find(pledgeDateSelector).val(formattedDate);
        const $datepicker = $modal.find(datepickerSelector);
        if (typeof $datepicker.datepicker === 'function') {
            $datepicker.datepicker('setDate', formattedDate);
        }
    }

    function setAmountChoice(amountChoice) {
        const isMatanah = amountChoice === 'Matanah';
        $modal.find(amountChoiceSelector).val(amountChoice);
        $modal.find(matanahSwitchSelector).prop('checked', isMatanah);
        $modal.find(amountRowSelector).toggleClass('matanah-mode', isMatanah);
        $modal.find(amountSelector).prop('disabled', isMatanah).prop('required', !isMatanah).val('');
        if (!isMatanah) {
            setAmountInputMode();
        }
    }

    function close() {
        $modal.modal('hide');
        $modal.find(amountErrorSelector).hide();
        const form = $form.get(0);
        if (form) {
            form.reset();
        }
        setAmountChoice('Amount');
        resetDate();
    }

    function open() {
        $modal.modal('show');
    }

    function amountIsInvalid(amount) {
        return amount <= Number(config.minTransactionAmount) || amount < Number(config.systemDonationMin);
    }

    function buildPayload(amount) {
        return {
            _token: csrfToken,
            amount: amount,
            custom_description: $modal.find('#custom_description').val(),
            save_type: $modal.find('#save_type').val(),
            added_by: $modal.find('#added_by').val(),
            campaign_id: $modal.find('#campaign_id').val(),
            amt_choice_option: $modal.find(amountChoiceSelector).val(),
            pledge_date: $modal.find(pledgeDateSelector).val(),
        };
    }

    function refreshPage(data) {
        $('#index_paging').empty().html(data.page_info).fadeIn('slow', function () {
            if ($('#index_paging .member-pledges-page').length) {
                $('body').addClass('member-pledges-full-page');
                if (typeof hooks.onContentRefresh === 'function') {
                    hooks.onContentRefresh();
                }
            } else {
                $('body').removeClass('member-pledges-full-page');
            }
            showAlertMsg('The new pledge was successfully added');
        });
    }

    function submit(e) {
        e.preventDefault();
        let amount = 0;
        if ($modal.find(amountChoiceSelector).val() === 'Amount') {
            amount = parseFloat($modal.find(amountSelector).val());
            if (amountIsInvalid(amount)) {
                $modal.find(amountErrorSelector).show();
                return false;
            }
        }

        $modal.modal('hide');
        cleanupBootstrapModalBody();
        localStorage.clear();

        $.ajax({
            type: 'post',
            url: routes.memberPledgeSave,
            cache: false,
            data: buildPayload(amount),
            success: function (data) {
                if (data.success) {
                    refreshPage(data);
                    return;
                }
                showAlertMsg(data.error, 'danger');
            },
            error: function () {
                showAlertMsg('A time out error occurred, please try again', 'danger');
                openIndexPage();
            }
        });

        return false;
    }

    function initDatepicker() {
        const $datepicker = $modal.find(datepickerSelector);
        if (typeof $datepicker.datepicker === 'function') {
            $datepicker.datepicker({
                autoclose: true,
                todayHighlight: false,
                endDate: '0d',
                clearBtn: false,
                orientation: 'top',
                dateFormat: 'mm/dd/yyyy'
            });
        }
        resetDate();
    }

    $modal.find(amountErrorSelector).hide();
    setAmountInputMode();
    initDatepicker();

    $modal
        .off('change' + bindNamespace, matanahSwitchSelector)
        .on('change' + bindNamespace, matanahSwitchSelector, function () {
            setAmountChoice($(this).prop('checked') ? 'Matanah' : 'Amount');
        });

    $modal
        .off('click' + bindNamespace, '[data-member-pledge-add-action="close"]')
        .on('click' + bindNamespace, '[data-member-pledge-add-action="close"]', function (event) {
            event.preventDefault();
            close();
        });

    $form
        .off('submit' + bindNamespace)
        .on('submit' + bindNamespace, submit);

    return { open, close };
}
